<template>
    <b-card no-body>

        <b-modal id="update-digital-license-number" title="Dijital Ehliyet Numarası Ekle" no-close-on-esc no-close-on-backdrop>
            <not-matched-employee-update-digital-license-number v-model="employee"></not-matched-employee-update-digital-license-number>
            <template #modal-footer><v-executer :loading="loading" text="Ekle" :action="update"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    pagination="server"
                    name="not-matched-employee"
                    :items-provider="provider"
                    search
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import NotMatchedEmployeeUpdateDigitalLicenseNumber from './components/NotMatchedEmployeeUpdateDigitalLicenseNumber.vue'

export default {
    components:{
        BCard,
        NotMatchedEmployeeUpdateDigitalLicenseNumber,
    },
    data() {
        return {
            fields:[
                { name:"Ad Soyad",key:"FullName",thClass:'w-50' },
                { name:"Bilgi",key:"DigitalDriverLicenseNumberIsExistsMessage",thClass:'w-50' }
            ],
            buttons:[
                { text:"Dijital Ehliyet Numarası Ekle",key:"add-digital-license-number",icon:"Edit3Icon",variant:"primary",action:this.updateDigitalLicenseNumber },
            ],
            loading:false,
            employee:{
                Id:null,
                DigitalDriverLicenseNumber:null,
                HasDigitalDriverLicenseNumber:null,
                HasDriverLicense:null
            }
        }
    },
    methods:{
        clearForm(){
            this.employee.Id = null
            this.employee.DigitalDriverLicenseNumber = null
            this.employee.HasDigitalDriverLicenseNumber = null
            this.employee.HasDriverLicense = null
        },
        provider(data){
            return EmployeeOperationsApi.Employee.NotMatchedTable(data)
        },
        updateDigitalLicenseNumber(item){
            this.clearForm()
            this.employee.Id = item.Id
            this.employee.DigitalDriverLicenseNumber = item.DigitalDriverLicenseNumber
            this.employee.HasDigitalDriverLicenseNumber = item.HasDigitalDriverLicenseNumber
            this.employee.HasDriverLicense = item.HasDriverLicense
            this.$showModal('update-digital-license-number')
        },
        update(){
            this.loading = true
            EmployeeOperationsApi.Employee.UpdateDigitalLicenseNumber(this.employee).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('update-digital-license-number')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>